import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UseOfProceedsModalUI from './UseOfProceedsModalUI.js'

class UseOfProceedsModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      useOfProceeds: this.props.loan.sanction.useOfProceedsF3,
      useOfProceedsError: null,
    }
  }

  render() {
    return (
      <UseOfProceedsModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        useOfProceeds={this.state.useOfProceeds}
        onUseOfProceedsChange={(event) => {this.setState({useOfProceeds: event.target.value})}}
        useOfProceedsError={this.state.useOfProceedsError}
        setUseOfProceedsError={(error) => { this.setState({ useOfProceedsError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/useOfProceedsAmounts`,
      this.onSubmitCallback, {
        useOfProceedsAmountF: this.state.useOfProceeds,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(UseOfProceedsModalSF)
